var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_584_22881",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 16,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 5.8328L10.7467 10.7985C10.3343 11.1608 9.66492 11.1597 9.25331 10.7976L3.6 5.8248V5.6H16.4V5.8328ZM3.6 14.4V7.956L8.49948 12.2645C9.3282 12.9932 10.6728 12.993 11.5005 12.266L16.4 7.9624V14.4H3.6ZM2 13.9915C2 15.1007 2.89451 16 3.99406 16H16.0059C17.1072 16 18 15.098 18 13.9915V6.00853C18 4.89925 17.1055 4 16.0059 4H3.99406C2.89277 4 2 4.90195 2 6.00853V13.9915Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_584_22881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4 5.8328L10.7467 10.7985C10.3343 11.1608 9.66492 11.1597 9.25331 10.7976L3.6 5.8248V5.6H16.4V5.8328ZM3.6 14.4V7.956L8.49948 12.2645C9.3282 12.9932 10.6728 12.993 11.5005 12.266L16.4 7.9624V14.4H3.6ZM2 13.9915C2 15.1007 2.89451 16 3.99406 16H16.0059C17.1072 16 18 15.098 18 13.9915V6.00853C18 4.89925 17.1055 4 16.0059 4H3.99406C2.89277 4 2 4.90195 2 6.00853V13.9915Z",
    fill: "#878E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 0H6C2.68629 0 0 2.68629 0 6V14C0 17.3137 2.68629 20 6 20H14C17.3137 20 20 17.3137 20 14V6C20 2.68629 17.3137 0 14 0Z",
    fill: "#878E99"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.2bff73f0431793fe070ad190d5d9cf2c.svg";
export { ForwardRef as ReactComponent };